import { DataModel } from "common/models/utility-models/base-model";

export class StudentAssignmentDetailsModel extends DataModel {
    topic: any = '';
    type: any = '';
    location: any = '';
    category_name: any = '';
    trainer_name: any = '';
    assignment_email: any = '';
    student_file_submit_date: any = '';
    start_date: any = '';
    end_date: any = '';
    display_filename: any = '';
    created: any = '';
    feedback_flag: any = '';
    student_feedback: any = '';
    description: any = '';
    assignment_uploaded_docucments: any = '';
    student_file_submit: any = '';
    trainer_feedback_to_student_date: any = '';
    trainer_feedback_to_student: any = '';
    student_ratings_date: any = '';
    student_ratings: any = '';
    file_url_path:any="";
    student_doc_url_path:any='';
    assignment_uploaded_documents:any='';
    assignment_timeslot:any='';
    assignment_id:any='';
    timeslot_id:any='';
    upload_assignment_description:any='';
    assignment_details:any='';
    upload_assignment_flag:any="";
    studentfeedback:string=''
    slotId:any="";
    isTrainerDetailsShow:any="";
    pageKey:any="";
    // upload_assignment:any="";
    upload_assignment: File | { name: string } = { name: '' };
    


  }


  export class CompletedPayload {
    assignment_id:any = ''
   student_ratings:any =''
studentfeedback:any = ''
pageKey:any="";


  }